import { render, staticRenderFns } from "./application-value-ProjectMngSystem.vue?vue&type=template&id=16870b14&scoped=true"
import script from "./application-value-ProjectMngSystem.vue?vue&type=script&lang=js"
export * from "./application-value-ProjectMngSystem.vue?vue&type=script&lang=js"
import style0 from "./application-value-ProjectMngSystem.vue?vue&type=style&index=0&id=16870b14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16870b14",
  null
  
)

export default component.exports